import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

interface Params {
  name: string;
  orgId?: string;
}

export function useDeleteMetricDefinition() {
  const { metricsService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<void, Error, Params>({
    mutationFn: ({ name, orgId }) =>
      metricsService.deleteMetricDefinition(name, { orgId }),
    onSuccess: (_, { name, orgId }) => {
      void queryClient.invalidateQueries({
        queryKey: ["metricDefinitions"],
      });
      queryClient.removeQueries({
        queryKey: ["metricDefinition", name, orgId],
      });
    },
  });
}
